import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import PropertyListingArea from "../../components/pages/Home/PropertyListingArea";
import PropertyCategoryCarousel from "../../components/pages/Home/PropertyCategoryCarousel";
import SidebarFilter from "../../components/pages/Home/SidebarFilter";
import { getAllProperties } from "../../services/propertyService";

export default function PropertySearchPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState({});
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // 🔹 Đồng bộ state filters từ URL
  useEffect(() => {
    const newFilters = {};
    searchParams.forEach((value, key) => {
      newFilters[key] = value;
    });
    setFilters(newFilters);
    setPage(1); // Reset page khi filter thay đổi từ URL
  }, [searchParams]);

  // 🔹 Gọi API khi filters hoặc page thay đổi
  useEffect(() => {
    const fetchProperties = async () => {
      setLoading(true);
      try {
        const data = await getAllProperties(filters, page, 12);
        setProperties(data.properties || []);
        setTotalPages(data.totalPages || 1);
      } catch (err) {
        console.error("Lỗi lấy danh sách BĐS:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProperties();
  }, [filters, page]);

  // 🔹 Hàm cập nhật filter (từ Sidebar hoặc Hero)
  const handleSetFilters = (newFilters) => {
    const query = { ...filters, ...newFilters };
    const searchParamsObj = {};
    Object.keys(query).forEach(key => {
      if (query[key]) searchParamsObj[key] = query[key];
    });
    setSearchParams(searchParamsObj); // Chỉ update URL → useEffect trên sẽ cập nhật filters
    setPage(1);
  };

  if (loading) {
    return <div className="text-center py-10">Đang tải dữ liệu...</div>;
  }

  return (
    <div className="space-y-6 text-blue-900">
      <section>
        <h2 className="text-2xl font-bold p-4">Danh mục BĐS nổi bật</h2>
        <PropertyCategoryCarousel />
      </section>

      <section className="flex gap-6">
        <SidebarFilter filters={filters} setFilters={handleSetFilters} />
        <PropertyListingArea
          filters={filters}
          setFilters={handleSetFilters}
          properties={properties}
          setPage={setPage}
          page={page}
          totalPages={totalPages}
        />
      </section>
    </div>
  );
}
